import ReactDatePicker, { type ReactDatePickerProps, registerLocale } from 'react-datepicker';
// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import jaDateTranslations from 'date-fns/locale/ja';

import { getTimeZoneDateInUtc, getUtcDateInTimeZone } from '@yoweb/utils/i18n/getTimeZoneDateIn';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import InputUI from '../form/Input/InputUI';

type DatePickerProps = {
  label: string;
  isRequired?: boolean;
  error?: string;
} & Omit<ReactDatePickerProps, 'customInput'>;

registerLocale('ja', jaDateTranslations);

export const DatePicker = ({
  label,
  isRequired,
  error,
  onChange,
  selected,
  ...props
}: DatePickerProps) => {
  const { lcLocale, language, timeZone } = useIntlMeta();

  return (
    <ReactDatePicker
      onChange={(date, event) => onChange(getTimeZoneDateInUtc(date, timeZone), event)}
      selected={getUtcDateInTimeZone(selected, timeZone)}
      locale={language}
      dateFormat={getDateFormatForLocale(lcLocale)}
      dateFormatCalendar={getCalendarDateFormatForLocale(lcLocale)}
      customInput={
        // Don't use the controlled Input, since it causes issues with ReactDatePicker
        <InputUI
          data-testid="datepicker-input"
          id="selected-date-input"
          name="selected-date-input"
          label={label}
          isRequired={isRequired}
          error={error}
        />
      }
      {...props}
    />
  );
};

const getCalendarDateFormatForLocale = (lcLocale: string) => {
  if (lcLocale === 'ja-jp') {
    return 'yyyy年 MM月';
  }

  return 'LLLL yyyy';
};

const getDateFormatForLocale = (lcLocale: string) => {
  if (lcLocale === 'ja-jp') {
    return 'yyyy/MM/dd';
  }

  return 'MMMM dd, yyyy';
};
